module.exports = class ServResponse {
    /**
     * @param {Number} httpCode
     * @param {string} errorMsg
     * @param {any} data
     * @memberof ServResponse
     */
    constructor(httpCode, errorMsg, data) {
        this.success = false;
        if (httpCode == 200 && !errorMsg) {
            this.success = true;
        }
        this.code = httpCode;
        this.message = errorMsg;
        this.payload = data;
    }

    toString = () => {
        return JSON.stringify(this);
    }
}